import React, { Component } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { withI18n } from '@lingui/react';
import { Trans } from '@lingui/macro';
import NavPanel from './NavPanel';
import CircularFloatingNav from './CircularFloatingNav';
import NewsletterPopup from './NewsletterPopup';
import { Link } from 'gatsby';
import KickStarterBanner from '../components/KickStarterBanner';
import moment from 'moment';
import { map } from 'lodash';
import classNames from 'classnames';
import Dropdown from './Dropdown';
import { prefix } from '../i18n-config';

// Images
import AdaLogo from './img/AdaLogo';
import FacebookIcon from './img/FacebookIcon';
import InstagramIcon from './img/InstagramIcon';
import TwitterIcon from './img/TwitterIcon';
import YoutubeIcon from './img/YoutubeIcon';
import AppleIcon from './img/AppleIcon';
import ThreadIcon from './img/TiktokIcon';
import TiktokIcon from './img/ThreadIcon';
import SpotifyIcon from './img/SpotifyIcon';

// styles
import '../styles/style.scss';

class TemplateWrapper extends Component {
  constructor(props) {

    super(props);
    this._$refTemplateWrapper = null;
    this.state = {
      $refTemplateWrapper: null,
      decoratorCls: '',
      onDevelopment: null,
      showNewsletterPopup: false,
      setShowNewsletterPopup: (val) => {
        this.setState({ showNewsletterPopup: val });
      },
      funcDecorator: (cls) => {
        this.setState({
          decoratorCls: cls,
        });
      },
    };

    this.languageOptions = {
      en: 'ENGLISH (CA)',
      fr: 'FRENCH (CA)'
    }
  }
  
  componentDidMount() {
    if (typeof window !== 'undefined' && !window.__fetchPatched) {
      window.__fetchPatched = true;
      const originalFetch = window.fetch;
      window.fetch = function(input, init) {
        if (typeof input === 'string' && input.includes('/v1/notify') && init && init.body) {
          try {
            const isDebug = localStorage.getItem('ada_debug_mode') === 'true';
            if (isDebug) {
              const body = JSON.parse(init.body);
              body.debug = true;
              init.body = JSON.stringify(body);
            }
          } catch (e) {
            // ignore
          }
        }
        return originalFetch.apply(this, arguments);
      };
    }

    const { location, pathName } = this.props;
    const onDevelopment = location.href.indexOf('staging') > -1 || location.href.indexOf('localhost') > -1;

    this.setState({
      onDevelopment: onDevelopment,
      $refTemplateWrapper: this._$refTemplateWrapper,
    });

    // Track site visits with a 1-hour cooldown
    if (typeof localStorage !== 'undefined') {
      const lastVisited = localStorage.getItem('ada_last_visited');
      const now = new Date().getTime();
      const oneHour = 60 * 60 * 1000;

      if (!lastVisited || (now - parseInt(lastVisited, 10) > oneHour)) {
        localStorage.setItem('ada_last_visited', now.toString());
        
        try {
          const apiUrl = process.env.GATSBY_API_URL || '';
          fetch(`${apiUrl}/v1/notify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ type: 'visit' }),
          }).catch(e => console.error(e));
        } catch (e) {
          // ignore
        }
      }
    }
    this.checkReferralParam();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location && prevProps.location && this.props.location.search !== prevProps.location.search) {
      this.checkReferralParam();
    }
  }

  checkReferralParam() {
    if (typeof window !== 'undefined' && this.props.location) {
      const search = this.props.location.search || '';
      const params = new URLSearchParams(search);
      const isTarget = params.get('r') === 'show260704' && [...params.keys()].length === 1;
      if (isTarget && !this.state.showNewsletterPopup) {
        this.setState({ showNewsletterPopup: true });
      }
    }
  }

  renderLanguageSwitcher() {
    const { lang, languages, location } = this.props;

    const getUrlPath = (language) => {
      let path = '';

      if (language === lang) {
        path = location.pathname;
      } else if (language === 'en') {
        path = location.pathname.substr(3);
      } else {
        path = `/${language}${location.pathname}`;
      }

      return path;
    }

    return <Dropdown className="language-select" title={`Language:  ${this.languageOptions[lang]}`}>
      {map(languages, (language, i) => {
        return <Link
          key={i}
          to={getUrlPath(language)}
        >
          {this.languageOptions[language]}
        </Link>
      })}
    </Dropdown>
  }

  renderMainFooter() {
    const { location, pathName, lang } = this.props;
    const onMainPage = location.pathname === '/' || location.pathname === '/fr/';
    const on404Page = pathName.includes('/404/');
    const langPrefix = prefix(lang);

    return (
      <footer className={classNames(`main-footer ${onMainPage ? 'on-main-page' : ''} ${on404Page ? 'on-404-page' : ''}`)}>
        <div className="wrapper container">
          <Link to={`${langPrefix}/`}>
            <AdaLogo />
          </Link>
          <div className="social-links">
            <a className="social-links__item _spotify" href="https://open.spotify.com/artist/2rCT4lUvXXRyeD4dlb5dL1?si=W_rplEWISxaUoalJacoRMw" target="_blank">
              <SpotifyIcon />
            </a>
            <a className="social-links__item _tiktok" href="https://www.tiktok.com/@adachan.music" target="_blank">
              <TiktokIcon />
            </a>
            <a className="social-links__item _thread" href="https://www.threads.net/@adachan.music" target="_blank">
              <ThreadIcon />
            </a>
            <a className="social-links__item _apple" href="https://music.apple.com/artist/ada-chan/1652987859" target="_blank">
              <AppleIcon />
            </a>
            <a className="social-links__item _youtube" href="https://www.youtube.com/@AdaTunes" target="_blank">
              <YoutubeIcon />
            </a>
            <a className="social-links__item _instagram" href="https://www.instagram.com/adachan.music" target="_blank">
              <InstagramIcon />
            </a>
            {/* 
            <a className="social-links__item _twitter" href="https://x.com/@adatunes" target="_blank">
              <TwitterIcon />
            </a>
            */}
          </div>
          <div className="footer-copyright-text">
            <Link to={`${langPrefix}/privacy-policy`} className="footer-privacy-link">
              <Trans>Privacy Policy</Trans>
            </Link>
            <span className="footer-divider"> | </span>
            <Trans>ALL RIGHTS RESERVED. COPYRIGHT &copy; {moment().format('Y')}. ADACHAN.COM. INTERSTELLAR PRODUCTIONS</Trans>
          </div>
        </div>
      </footer>
    );
  }

  render() {
    const { pathName, children, location, lang } = this.props;
    const isLabPage = pathName.includes('lab') || pathName.includes('process');
    const lightCls = isLabPage ? 'page-is-light' : '';
    const langPrefix = prefix(lang);
    
    const {
      $refTemplateWrapper, funcDecorator, decoratorCls
    } = this.state;

    const onMainPage = location && (location.pathname === '/' || location.pathname === '/fr/');
    const withOverlayCls = '';

    return (
      <HelmetProvider>
        <div
          ref={(_mount) => {
            this._$refTemplateWrapper = _mount;
          }}
          className={`main-wrapper ${lightCls} ${decoratorCls} ${withOverlayCls}`}
          >
          <TemplateWrapperContext.Provider
            value={{ 
              $refTemplateWrapper, 
              funcDecorator, 
              setShowNewsletterPopup: this.state.setShowNewsletterPopup 
            }}
          >
            <Helmet defaultTitle="Ada Chan" titleTemplate="%s - Announcement soon">
              <meta name="og:type" content="website" />
              <meta name="og:site_name" content="Ada Chan" />
              <title>Ada Chan</title>
              <meta name="description" content="" />
              <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            </Helmet>
            
            <NavPanel
              {...this.props}
            />
            <CircularFloatingNav
              {...this.props}
              onNewsletterClick={() => this.setState({ showNewsletterPopup: true })}
            />
            <main className="main-content">
              { children }
            </main>
            {this.renderMainFooter()}
            <NewsletterPopup
              show={this.state.showNewsletterPopup}
              onClose={() => this.setState({ showNewsletterPopup: false })}
            />
          </TemplateWrapperContext.Provider>
        </div>
      </HelmetProvider>
    );
  }
}

export default withI18n()(TemplateWrapper);
export const TemplateWrapperContext = React.createContext();
